import { authHeader, handleResponse } from '../helpers';
export const menuService = {
    fetchMenuData,
    getAccessRight
};
 
function fetchMenuData(roleId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetUserMenu/${roleId}`, requestOptions)
        .then(handleResponse);
}

function getAccessRight(roleId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetAccessRight/${roleId}`, requestOptions)
        .then(handleResponse);
}


